import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-async-light';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
SyntaxHighlighter.registerLanguage('python', python);
import { breakpoints } from '@/layouts/breakpoints'
import BreadCrumbs from '@/components/landing/common/Breadcrumb';
import Trackx from '@/components/landing/common/Tracx';


const StyledComp = styled.div`
  /* ── Mobile / tablet: stacked (original) ── */
  .hero {
    padding: 80px 48px;
    padding-top: 200px;
    height: 100vh;
    min-height:700px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 1024px) {
      height: auto;
      width: 80%;
      min-height:0px;
      display: flex;
    }
    @media (max-width: ${breakpoints.medium}) {
      width: 100%;
      max-width: 100%;
      padding: 80px 20px;
      padding-top: 150px;
    }
  }
  .hero h1 {
    font-size: 56px;
    font-weight: 400;
    line-height: 1.1;
    padding-top: 24px;;
    max-width: 1000px;
    margin: 0 0 16px;
    @media (max-width: ${breakpoints.medium}) {
      width: calc(100% - 40px);
      font-size: 40px;
    }
    @media (max-width: ${breakpoints.small}) {
      width: calc(100% - 40px);
    }
  }
  .hero p {
    font-size: 15px;
    max-width: 380px;
    margin: 0 0 32px;
    line-height: 1.6;
    @media (max-width: ${breakpoints.small}) {
      width: calc(100% - 40px);
    }
  }
  .ctas {
    display: flex;
    gap: 12px;
    margin-bottom: 0;
  }
  .cta-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: #111;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    transition: background 0.15s;
  }
  .cta-primary:hover {
    background: #333;
  }
  .cta-secondary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: transparent;
    color: #111;
    border: 1px solid #d0d0d0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    transition: border-color 0.15s, background 0.15s;
  }
  .cta-secondary:hover {
    border-color: #999;
    background: #f5f5f5;
  }
  .tabs {
    display: flex;
    border-bottom: 1px solid #e5e5e5;
    background: #fff;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .tab {
    padding: 16px 32px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    transition: color 0.15s;
  }
  .tab.active {
    color: #111;
    border-bottom: 2px solid #111;
    background: #f5f5f5;
  }
  .tab:hover:not(.active) {
    color: #333;
  }
  .demo-area {
    background: linear-gradient(135deg, #e8c4a0 0%, #c4855a 100%);
    background-image: ${props => (props.$bg) ? 'url(/code/' + props.$bg + ')' : ''};
    background-size: cover;
    padding: 60px 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    opacity:1;
    transition-duration: 0.2s;
    &.fading{
      opacity:0;
      transition-duration: 0.2s;
    }

    @media (max-width: ${breakpoints.small}) {
      padding: 40px 20px;
    }
  }
  .code-window {
    background: rgb(250,250,250);
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    width: 100%;
    max-width: 640px;
    overflow: hidden;
  }
  .code-window-titlebar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    background: #f7f7f7;
    border-bottom: 1px solid #e8e8e8;
  }
  .traffic-lights {
    display: flex;
    gap: 7px;

    @media (max-width: ${breakpoints.small}) {
      display:none;
    }
  }

  .traffic-light {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }
  .tl-red    { background: #ff5f57; }
  .tl-yellow { background: #febc2e; }
  .tl-green  { background: #28c840; }
  .code-window-filename {
    font-size: 12px;
    color: #888;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
  }
  .code-window-copy {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: #999;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    transition: color 0.15s;
  }
  .code-window-copy:hover {
    color: #555;
  }
  .code-window-body {
    padding: 20px 22px;
    background: rgb(250,250,250);
    min-height: 240px;
  }
  .code-window-body pre {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    font-size: 13.5px !important;
    line-height: 1.65 !important;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace !important;
  }

  /* ── Desktop: side-by-side layout ── */
  @media (min-width: 1024px) {
    .hero-desktop-wrapper {
      display: flex;
      align-items: stretch;
      min-height: 100vh;
    }

    /* Left column: copy */
    .hero-copy-col {
      flex: 0 0 420px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .hero {
      padding: 80px 48px;
      padding-top: 80px;
      min-width: 40vw;
      max-width: 600px;
    }
    .hero h1 {
      font-size: 44px;
      width: 90%;
    }

    /* Right column: tabs + demo */
    .hero-demo-col {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0;
    }
    .tabs {
      flex-shrink: 0;
      margin-top: 200px;
    }
    .demo-area {
      flex: 1;
      min-height: 0;
    }
  }
`;

const CopyIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
  </svg>
);

const HeroSection = ({tabs, title, body, crumb, docs}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabIndicator, setActiveTabIndicator] = useState(0);
  const [copied, setCopied] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const tabRefs = useRef([]);

  const handleCopy = () => {
    navigator.clipboard.writeText(tabs[activeTab].code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const current = tabs[activeTab];

  return (
    <StyledComp $bg={tabs[activeTab].bg}>

      <div className="hero-desktop-wrapper">
        {/* Left: copy */}
        <div className="hero-copy-col">
          <div className="hero">
            <BreadCrumbs
              crumbs={[
                {name: 'Products',path: '/products'},
                crumb
              ]}
            />
            <h1>{title}</h1>
            <p>{body}</p>
            <div className="ctas">
              <Link to="/dashboard/api-keys" className="cta-primary">Get API Key</Link>
              <Link to={docs ? docs : '/docs'} className="cta-secondary">Read Docs</Link>
            </div>
          </div>
        </div>

        {/* Right: tabs + demo */}
        <div className="hero-demo-col">
          <Trackx>
            <div className="tabs">
              {tabs.map((tab, i) => (
                <div
                  key={i}
                  ref={(el) => (tabRefs.current[i] = el)}
                  className={`tab${activeTabIndicator === i ? ' active' : ''}`}
                  onClick={() => {
                    setActiveTabIndicator(i)
                    tabRefs.current[i]?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'nearest',
                      inline: 'nearest',
                    })
                    setIsFading(true)
                    setTimeout(() => {
                      setActiveTab(i)
                      setTimeout(() => { setIsFading(false) }, 100)
                    }, 250)
                  }}
                >
                  {tab.label}
                </div>
              ))}
            </div>
          </Trackx>

          <div className={`demo-area ${isFading ? 'fading' : ''}`}>
            <div className="code-window">
              <div className="code-window-titlebar">
                <div className="traffic-lights">
                  <div className="traffic-light tl-red" />
                  <div className="traffic-light tl-yellow" />
                  <div className="traffic-light tl-green" />
                </div>
                <span className="code-window-filename">{current.filename}</span>
                <button className="code-window-copy" onClick={handleCopy}>
                  <CopyIcon />
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
              <div className="code-window-body">
                <SyntaxHighlighter
                  style={oneLight}
                  language={current.language}
                >
                  {current.code}
                </SyntaxHighlighter>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledComp>
  );
};

export default HeroSection;
